import './App.css';
import React from "react";
import NewNavbar from './components/NewNavbar';


function App() {
  return (
    <NewNavbar />
  );
}

export default App;
